import { toast } from "sonner";

export const favSavedToast = (listing, lang) => {
  const fixed = listing?.price_type === "fixed" && listing?.price != null && !listing?.lf_type;
  const fr = lang === "fr";
  if (fixed) toast.success(fr ? "Enregistré ! Nous vous écrirons si le prix baisse." : "Saved! We'll email you if the price drops.");
  else toast.success(fr ? "Ajouté à vos favoris" : "Saved to your favourites");
};
